<template>
  <div class="iframe-container">
    <iframe 
      id="powerBIcontainer" 
      frameborder="1" 
      allowfullscreen
      :src="externalUrl">
    </iframe>
  </div>
</template>

<style scoped>
  .iframe-container {
    width: 100%;
    height: 100vh; /* altura completa */
  }

  .iframe-container iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
</style>

<script>
  export default {
    name: "DashboardIntranet",
    data() {
      return {
        externalUrl: ""
      }
    },
    mounted() {
      this.externalUrl = "https://tableros-area-financiera.vercel.app/";
    }
  }
</script>
